module.exports = __webpack_public_path__ + "media/assets/images/bulloni_digitali/scambio-file-c9e304dbd71f3784491d1123fdf0d77f.png";